var map = {
	"./Authentication/Authentication/actions/forgotPassword.js": 7412,
	"./Authentication/Authentication/actions/generatePassword.js": 7623,
	"./Authentication/Authentication/actions/refreshToken.js": 6270,
	"./Authentication/Authentication/actions/resetPassword.js": 1293,
	"./Authentication/Authentication/actions/signIn.js": 1397,
	"./Authentication/Authentication/actions/signOut.js": 5297,
	"./Authentication/Authentication/actions/signUp.js": 6299,
	"./Authentication/Authentication/actions/validatePassword.js": 2789,
	"./Finances/Deposit/actions/getDepositResource.js": 1938,
	"./Finances/Wallet/actions/getCoinResource.js": 2240,
	"./Finances/Wallet/actions/getTransactionResource.js": 7005,
	"./Finances/Wallet/actions/getWalletResource.js": 4273,
	"./Finances/Wallet/actions/reloadTransactions.js": 2702,
	"./Finances/Withdraw/actions/getWithdrawResource.js": 208,
	"./Profile/Profile/actions/deleteProfile.js": 7083,
	"./Profile/Profile/actions/getCountryResource.js": 1451,
	"./Profile/Profile/actions/getProfileResource.js": 1316,
	"./Profile/Profile/actions/uploadDocument.js": 8533,
	"./Trading/Chart/actions/getBarResource.js": 142,
	"./Trading/Chart/actions/getBars.js": 5999,
	"./Trading/Chart/actions/onReady.js": 888,
	"./Trading/Chart/actions/resolveChartStream.js": 9298,
	"./Trading/Chart/actions/resolveSymbol.js": 8621,
	"./Trading/Chart/actions/subscribeBars.js": 8698,
	"./Trading/Chart/actions/unsubscribeBars.js": 1659,
	"./Trading/Chart/actions/updateBar.js": 3755,
	"./Trading/Deal/actions/createPosition.js": 5521,
	"./Trading/OrderBook/actions/fillOrders.js": 7943,
	"./Trading/OrderBook/actions/fillTrades.js": 6484,
	"./Trading/OrderBook/actions/getOrderResource.js": 7479,
	"./Trading/OrderBook/actions/getTradeResource.js": 3240,
	"./Trading/OrderBook/actions/makeOrder.js": 4217,
	"./Trading/OrderBook/actions/makeTrade.js": 9194,
	"./Trading/OrderBook/actions/resolveOrderStream.js": 8482,
	"./Trading/OrderBook/actions/resolveTradeStream.js": 2912,
	"./Trading/Position/actions/getHistoryResource.js": 640,
	"./Trading/Position/actions/getPositionResource.js": 6322,
	"./Trading/Position/actions/plCalculate.js": 650,
	"./Trading/Quotes/actions/getCommodityResource.js": 1077,
	"./Trading/Quotes/actions/getCryptoResource.js": 4548,
	"./Trading/Quotes/actions/getMarketResource.js": 5121,
	"./Trading/Quotes/actions/getStockResource.js": 4893,
	"./Trading/Quotes/actions/quoteNormalization.js": 6595,
	"./Trading/Quotes/actions/resolveQuotesStream.js": 4161,
	"./Trading/Quotes/actions/sortBy.js": 7383
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9747;